<!-- rendering from templates -->
<div class="panel-content" id="queryContent" [innerHtml]="html | sanitizeHtml"></div>
<!-- rendering from templates end -->
<div class="mainClass" [formGroup]="queryForm" #formDirective="ngForm">
  <div class="mytooltip" matTooltipShowDelay="1000">
    <h3 id="feature-label" class="query-label" title="{{ toolTip['query-feature-layer'] }}">
      Feature Layer
    </h3>
    <!-- <h2>{{defaultValue}}</h2> -->
    <select formControlName="feature" id="select-layer" (change)="changeDefaultName($event)">
      <ng-container *ngFor="let layer of layers; index as i">
        <option *ngIf="layer.selectable && layer.queryable <= mapAccessLevel && layer.queryable!==999"
          [value]="layer.id" selected>
          {{ layer.name }}
        </option>
      </ng-container>
    </select>
  </div>

  <div class="subDiv" formArrayName="data" *ngFor="let controls of dataArray.controls; let i = index">
    <div [formGroupName]="i">
      <div class="mytooltip">
        <h3 id="feature-label" class="query-label attribute" title="{{ toolTip['query-attribute-field'] }}">
          Attribute Field
        </h3>
        <select id="select-layer" class="select_attr" formControlName="attribute" (click)="getQuerryDropdownValue($event)">
          <ng-container *ngIf="queryForm.value.feature">
            <ng-container *ngFor="let layer of layers; index as j">
              <ng-container *ngIf="
                  layer.id.toString() === queryForm.value.feature.toString()
                ">
                <ng-container *ngFor="let fields of layer.fields; index as k">
                  <option *ngIf="fields.searchable"  class="attr-option" [value]="fields.searchable ? fields.id : ''"
                    [selected]="i === 0 && k === 0">
                    <!-- {{fields.id}} -->
                    {{ fields.name }}
                  </option>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </select>
      </div>

      <div class="mytooltip" *ngIf="!query_dropdown">
        <h3 id="feature-label" class="query-label relation" title="{{ toolTip['query-relationship'] }}">
          Relationship
        </h3>
        <select style="font-size: 18px !important;" id="select-layer" formControlName="relation">
          <option value="almost" selected>≈</option>
          <option value="exact">=</option>
          <option value="ne">≠</option>
          <option value="gt">&gt;</option>
          <option value="lt">&lt;</option>
          <option value="gte">≥</option>
          <option value="lte">≤</option>
        </select>
      </div>

      <div class="mytooltip">
        <h3 id="feature-label" class="query-label lastDropDown" title="{{ toolTip['query-condition'] }}">
          Condition
        </h3>
        <input *ngIf="!query_dropdown" id="select-layer-last" type="text" class="inputField" formControlName="condition"
          (keyup.enter)="submit()" />
          <select *ngIf="query_dropdown" style="font-size: 18px !important;" id="select-layer" formControlName="condition">
            <ng-container *ngFor="let fields of query_dropdown_list; index as k">
              <option  class="attr-option" [value]="fields">
                <!-- {{fields.id}} -->
                {{ fields }}
              </option>
            </ng-container>
          </select>
        <div class="lastDiv"></div>
        <a *ngIf="clickArray[i]" class="query-remove commonBtnQuery">and<span class="span-x" (click)="
              clickArray[i] === undefined ? addAnother(i) : removeSkill(i)
            ">x</span></a>
        <a *ngIf="!clickArray[i]" class="query-add commonBtnQuery" title="Add further delimiting query."
          (click)="clickArray[i] === undefined ? addAnother(i) : removeSkill(i)">Add Another</a>
      </div>
    </div>
  </div>
</div>

<div class="buttonDiv">
  <a class="closer tool-toolTip">
    <img (click)="closeLeft()" class="closer-img common-btns" src="/assets/img/tools/close-pv3.png" alt="closer" />
    <span class="tooltiptext tip-bottom" [innerHtml]="mapServices.templatetoolTips['close_left_panel']"></span>
  </a>
  <a class="closer" [tooltip]="queryToolTip" [options]="myOptions4">
    <img (click)="clearForm()" class="arrow-img common-btns" src="/assets/img/tools/two-circling-arrows.png"
      alt="closer" /></a>
  <a class="closer">
    <button (click)="submit()" class="go-img common-btns closerToolTip" src="/assets/img/tools/two-circling-arrows.png"
      alt="closer">
      GO
    </button>
    <span class="tooltiptext1 tip-bottom"><span>Run query</span> <br />now</span>
  </a>
</div>
<app-loader></app-loader>
